/**
 * 說明 : 案件資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// // 新增案件
export const addCase = createAsyncThunk(
  'case/addCase',
  async ({caseData, files}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postMutiWithAuth(
        '/case',
        {postData: caseData, files},
        token,
      );
      return data;
    } catch (err) {
      console.error('add elevator error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改案件
export const editCase = createAsyncThunk(
  'case/editCase',
  async ({caseData, files}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putMutiWithAuth(
        '/case',
        {putData: caseData, files: files},
        token,
      );
      return data;
    } catch (err) {
      console.error('edit case error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得案件資料
export const fetchCase = createAsyncThunk(
  'case/fetchCase',
  async (
    {caseNumber, withSatisfaction, withAssignmentReport, withAppearances},
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `/case/${caseNumber}`,
        {withSatisfaction, withAssignmentReport, withAppearances},
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch elevator error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得專案清單列表
export const fetchCaseList = createAsyncThunk(
  'case/fetchCaseList',
  async (
    {
      casePriority,
      flgStatus,
      startTime,
      endTime,
      requireSatisfaction,
      withSatisfaction,
      batchMachineCheck,
      raw,
    },
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/case',
        {
          casePriority,
          flgStatus,
          startTime,
          endTime,
          requireSatisfaction,
          withSatisfaction,
          batchMachineCheck,
          raw,
        },
        token,
      );
      return data;
    } catch (err) {
      //   console.error('fetch elevator list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const sendSatisfactionMessage = createAsyncThunk(
  'case-satisfaction/survery/send',
  async ({caseNumber}, {getState, rejectWithValue}) => {
    try {
      return await BaseAPI.postWithAuth(
        `/case/${caseNumber}/satisfaction/survey/send`,
        undefined,
        getState().auth.token,
      );
    } catch (error) {
      console.error('send notification error', error);
      throw error.response.data;
      rejectWithValue(error.response.data);
    }
  },
);

// 取得有效的案件名稱選單
export const fetchCaseSelection = createAsyncThunk(
  'case/fetchCaseSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/selection/case', null, token);
      return data;
    } catch (err) {
      // console.error('fetch case selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的案件名稱選單
export const deleteCaseAttachment = createAsyncThunk(
  'case/deleteCaseAttachment',
  async ({fileName}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.deleteWithAuth(
        '/aiDispatch/attachment',
        {fileName},
        token,
      );
      return data;
    } catch (err) {
      // console.error('fetch case selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const generateCaseNumber = createAsyncThunk(
  'case/generateCaseNumber',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/caseNumber', {}, token);
      return data;
    } catch (err) {
      // console.error('fetch case selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
